import { render, staticRenderFns } from "./snowprinces.vue?vue&type=template&id=b01a1366"
import script from "./snowprinces.vue?vue&type=script&lang=js"
export * from "./snowprinces.vue?vue&type=script&lang=js"
import style0 from "./snowprinces.vue?vue&type=style&index=0&id=b01a1366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports